import { DeviceMS } from '../models/Device';
import { DeviceInfo } from '../models/DeviceDetail';
import { ExecutionInfo } from '../models/Execution';
import { SECTION_REFRESH_STATUS, SectionRefreshVm } from '../models/SectionRefreshVm';
import { UiProfileSection } from '../models/UiProfile';

export function isDeviceRefreshable(device: DeviceMS | undefined, section: UiProfileSection): boolean {
    if (!section.refreshable) return false;

    const categories = device?.categories ?? [];
    const isSensor = categories.includes('sensor') && device?.product_profile !== 'window_sensor';
    const isZigbeeRemote = device?.type === 'generic_zigbee' && categories.includes('remote_controller');

    return !isSensor && !isZigbeeRemote;
}

export function computeSectionRefreshVm(
    device: DeviceInfo,
    uiSection: UiProfileSection,
    gatewayAvailable: boolean,
    sectionRefreshTasks: readonly ExecutionInfo[] | undefined,
): SectionRefreshVm {
    if (!isDeviceRefreshable(device.rawData, uiSection)) {
        return { status: SECTION_REFRESH_STATUS.NONE };
    }
    if (!gatewayAvailable) {
        return {
            status: SECTION_REFRESH_STATUS.DISABLED,
            tooltip: 'REFRESH_SECTION_NOT_AVAILABLE_BECAUSE_GATEWAY_DOWN',
        };
    }
    if (!device.available) {
        return {
            status: SECTION_REFRESH_STATUS.DISABLED,
            tooltip: 'REFRESH_SECTION_NOT_AVAILABLE_BECAUSE_DEVICE_DOWN',
        };
    }
    const refreshInProgress = !!sectionRefreshTasks?.some(
        (task) => task.deviceId === device.id && task.section === uiSection.title,
    );
    return { status: refreshInProgress ? SECTION_REFRESH_STATUS.IN_PROGRESS : SECTION_REFRESH_STATUS.ENABLED };
}
